import React from "react";

// The Mtaa "M" glyph: left stroke = foreground (black/white), centre diagonal = Kenyan red,
// right leg = Kenyan green. Sits flush against the "taa" text so it reads as one word: Mtaa.
export function MtaaMark({ className = "h-7 w-7", title = "Mtaa" }) {
  return (
    <svg viewBox="0 0 30 32" className={className} role="img" aria-label={title} fill="none" xmlns="http://www.w3.org/2000/svg" data-testid="mtaa-mark">
      <path d="M4 28V6L14 18" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14 18L24 6" stroke="hsl(var(--brand-red))" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M24 6V28" stroke="hsl(var(--brand-green))" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function MtaaWordmark({ compact = false, className = "" }) {
  return (
    <span className={"flex flex-col leading-none text-foreground " + className} data-testid="mtaa-wordmark">
      <span className="inline-flex items-center">
        <MtaaMark className="h-7 w-7" />
        <span className="-ml-1.5 font-display text-2xl font-extrabold tracking-tight">taa</span>
      </span>
      {!compact && <span className="ml-0.5 mt-0.5 text-[9px] font-bold uppercase tracking-[0.12em] text-muted-foreground">Buy. Sell. Belong.</span>}
    </span>
  );
}
